import React, { useState, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
export default function useConfirmDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogOptions, setDialogOptions] = useState({
    title: "Are you sure?",
    description: "",
    onConfirm: () => {},
    confirmText: "Yes",
    cancelText: "No",
  });

  const ConfirmDialog = useCallback(() => {
    if (!isOpen) return null;

    return (
      <Dialog
        open={isOpen}
        onClose={() => {}}
        disableEscapeKeyDown
        onBackdropClick={() => {}}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "12px",
            padding: "24px",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle style={{ padding: "0 0 16px 0" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="h6"
              style={{
                fontWeight: "bold",
                fontSize: "20px",
                color: "#333",
                textAlign: "center",
              }}
            >
              {dialogOptions.title}
            </Typography>
            <IconButton onClick={() => setIsOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider style={{ marginBottom: "20px" }} />
        <DialogContent style={{ padding: "0 0 24px 0" }}>
          <Typography
            style={{
              fontSize: "16px",
              color: "#666",
            }}
          >
            {dialogOptions.description}
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: 0, justifyContent: "flex-end" }}>
          <Button
            onClick={() => {
              setIsOpen(false);
              dialogOptions.onCancel?.();
            }}
            style={{
              textTransform: "none",
              color: "#333",
              fontWeight: "bold",
              padding: "6px 16px",
            }}
          >
            {dialogOptions.cancelText || "No"}
          </Button>
          <Button
            onClick={() => {
              setIsOpen(false);
              dialogOptions.onConfirm?.();
            }}
            style={{
              textTransform: "none",
              backgroundColor: "#d32f2f",
              color: "white",
              fontWeight: "bold",
              padding: "6px 16px",
              "&:hover": {
                backgroundColor: "#b71c1c",
              },
            }}
            variant="contained"
          >
            {dialogOptions.confirmText || "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }, [isOpen, dialogOptions]);

  const showConfirmDialog = ({
    title = "Delete Bank Account",
    description = "Are you sure you want to delete the bank account?",
    onConfirm,
    onCancel,
    confirmText = "Yes",
    cancelText = "No",
  }) => {
    setDialogOptions({
      title,
      description,
      onConfirm,
      onCancel,
      confirmText,
      cancelText,
    });
    setIsOpen(true);
  };

  return {
    ConfirmDialog,
    showConfirmDialog,
  };
}
